// extracted by mini-css-extract-plugin
export default {"cls1":"zhEO5f5KnjLthA6pUTLd","cls2":"Zz6SaYxhmevBVWBVfj2j zhEO5f5KnjLthA6pUTLd"};